import { createFileRoute } from "@tanstack/react-router"
import { ProfileRankPage } from "@/pages/profile/rank"

export const Route = createFileRoute("/_authenticated/profile/rank")({
	component: ProfileRankPage,
})
